import { addYears } from 'date-fns';
import { getNow } from './getNow';

export const DISPLAY_DATE_FORMAT_LONG = 'dd MMM yyyy';
export const DISPLAY_TIME_FORMAT_LONG = 'h:mm aaa';
export const DISPLAY_TIME_FORMAT_SHORT = 'HH:mm';
export const DEFAULT_MAX_DATE = addYears(getNow(), 2);
